export { default } from './HubHeroView';



// WEBPACK FOOTER //
// ./src/components/views/HubHeroView/index.js